import React, {Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import date from 'date-and-time';

import HeaderEjercicios from '../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../Escritorio/Instrucciones';
import BotoneraBottom from '../Compartidos/BotoneraBottom';
import useConfigAuth from '../../../Hooks/useConfigAuth';

import { finalizarEjercicioAction, setearEjercicioAction, setearUrlAnteriorAction } from '../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../actions/almacenarEjercicioActions';

// css
import {Flex, Ilustracion, Btn} from '../../Css/MetodosCSS/StyledCCIntrasilabica';
import { Icono } from '../../Css/MetodosCSS/StyledCCLexica';
import { AvanzarBtn, AvanzarImg } from '../../Css/StyledMatematica';

const instrucciones = 'Vamos a escuchar unas sílabas y vas a tener que unirlas para formar una palabra. Luego, seleccionarás el dibujo correspondiente';
const miniInstrucciones = 'Selecciona el dibujo correspondiente';

const SCR3 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [count, setCount] = useState(1);
    const [disable, setDisable] = useState(false);
    const [comparar, setComparar] = useState([]);
    const [randomPalabra, setRandomPalabra] = useState([]);
    const [indexes, setIndexes] = useState();
    const [contarTiempo, setContarTiempo] = useState([]);
    const [ultimoTiempo, setUltimoTiempo] = useState(false);
    const [resultado, setResultado] = useState([]);
    const [contadorA, setContadorA] = useState(0);
    const [contadorB, setContadorB] = useState(0);
    const [contadorC, setContadorC] = useState(0);
    const [contadorD, setContadorD] = useState(0);
    const [contadorE, setContadorE] = useState(0);
    const [contadorF, setContadorF] = useState(0);
    const [contadorG, setContadorG] = useState(0);
    const [ejercicioElegido, setEjercicioElegido] = useState('');
    const [elegido, setElegido] = useState('');

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const informacion = useSelector(state => state.informacion.info_DB);

    const play1 = new Audio(`/sounds/${comparar?.sonido_url_1}.mp3`);
    const play2 = new Audio(`/sounds/${comparar?.sonido_url_2}.mp3`);
    const play3 = new Audio(`/sounds/${comparar?.sonido_url_3}.mp3`);
    const play4 = new Audio(`/sounds/${comparar?.sonido_url_4}.mp3`);
    const play5 = new Audio(`/sounds/${comparar?.sonido_url_5}.mp3`);
    const play6 = new Audio(`/sounds/${comparar?.sonido_url_6}.mp3`);
    const play7 = new Audio(`/sounds/${comparar?.sonido_url_7}.mp3`);

    const play = (valor) => {
        switch(valor){
            case 1:
                if(comparar?.sonido_url_1){
                    play1.play();
                    setContadorA(contadorA+1)
                }
                break;
            case 2:
                if(comparar?.sonido_url_2){
                    play2.play();
                    setContadorB(contadorB+1)
                }
                break;
            case 3:
                if(comparar?.sonido_url_3){
                    play3.play();
                    setContadorC(contadorC+1)
                }
                break;
            case 4:
                if(comparar?.sonido_url_4){
                    play4.play();
                    setContadorC(contadorD+1)
                }
                break;
            case 5:
                if(comparar?.sonido_url_5){
                    play5.play();
                    setContadorC(contadorE+1)
                }
                break;
            case 6:
                if(comparar?.sonido_url_6){
                    play6.play();
                    setContadorC(contadorF+1)
                }
                break;
            case 7:
                if(comparar?.sonido_url_7){
                    play7.play();
                    setContadorC(contadorG+1)
                }
                break;
            default:
        }
    }

    const resultadoBase = [
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:"", contador_b:"", contador_c:"", contador_d:"", contador_e:"", contador_f:"", contador_g:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:"", contador_b:"", contador_c:"", contador_d:"", contador_e:"", contador_f:"", contador_g:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:"", contador_b:"", contador_c:"", contador_d:"", contador_e:"", contador_f:"", contador_g:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:"", contador_b:"", contador_c:"", contador_d:"", contador_e:"", contador_f:"", contador_g:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:"", contador_b:"", contador_c:"", contador_d:"", contador_e:"", contador_f:"", contador_g:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:"", contador_b:"", contador_c:"", contador_d:"", contador_e:"", contador_f:"", contador_g:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:"", contador_b:"", contador_c:"", contador_d:"", contador_e:"", contador_f:"", contador_g:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:"", contador_b:"", contador_c:"", contador_d:"", contador_e:"", contador_f:"", contador_g:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", contador_a:"", contador_b:"", contador_c:"", contador_d:"", contador_e:"", contador_f:"", contador_g:"", ejemplo:""}
    ];
    
    const verificar = (e) => {
        e.preventDefault();
        if(!elegido){
            return;
        }
        if(comparar.ejemplo == 1) {
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.palabra_1;
            newList[count-1].palabra_usada = ejercicioElegido;
            newList[count-1].puntaje = 0;
            newList[count-1].contador_a = contadorA;
            newList[count-1].contador_b = contadorB;
            newList[count-1].contador_c = contadorC;
            newList[count-1].contador_d = contadorD;
            newList[count-1].contador_e = contadorE;
            newList[count-1].contador_f = contadorF;
            newList[count-1].contador_g = contadorG;
            newList[count-1].ejemplo = 1;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setContadorA(0);
                    setContadorB(0);
                    setContadorC(0);
                    setContadorD(0);
                    setContadorE(0);
                    setContadorF(0);
                    setContadorG(0);
                    setElegido('');
                    setEjercicioElegido('');
                }, 100);
            } else {
                setUltimoTiempo(true);
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
            return
        }
        if(ejercicioElegido.toUpperCase() !== comparar.palabra_1.toUpperCase()) {
            console.log('mal');
            setDisable(true);
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.palabra_1;
            newList[count-1].palabra_usada = ejercicioElegido;
            newList[count-1].puntaje = 0;
            newList[count-1].contador_a = contadorA;
            newList[count-1].contador_b = contadorB;
            newList[count-1].contador_c = contadorC;
            newList[count-1].contador_d = contadorD;
            newList[count-1].contador_e = contadorE;
            newList[count-1].contador_f = contadorF;
            newList[count-1].contador_g = contadorG;
            newList[count-1].ejemplo = 0;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setContadorA(0);
                    setContadorB(0);
                    setContadorC(0);
                    setContadorD(0);
                    setContadorE(0);
                    setContadorF(0);
                    setContadorG(0);
                    setElegido('');
                    setEjercicioElegido('');
                }, 100);
            } else {
                setUltimoTiempo(true);
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
        } else {
            console.log('bien');
            setDisable(true);
            const newList = JSON.parse(JSON.stringify(resultado));
            let puntajeParcial;
            if(contadorA > 1 || contadorB > 1 || contadorC > 1){
                puntajeParcial = 1;
            } else {
                puntajeParcial = 2;
            }
            newList[count-1].palabra_correcta = comparar.palabra_1;
            newList[count-1].palabra_usada = ejercicioElegido;
            newList[count-1].puntaje = puntajeParcial;
            newList[count-1].contador_a = contadorA;
            newList[count-1].contador_b = contadorB;
            newList[count-1].contador_c = contadorC;
            newList[count-1].contador_d = contadorD;
            newList[count-1].contador_e = contadorE;
            newList[count-1].contador_f = contadorF;
            newList[count-1].contador_g = contadorG;
            newList[count-1].ejemplo = 0;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setContadorA(0);
                    setContadorB(0);
                    setContadorC(0);
                    setContadorD(0);
                    setContadorE(0);
                    setContadorF(0);
                    setContadorG(0);
                    setElegido('');
                    setEjercicioElegido('');
                }, 100);
            } else {
                setUltimoTiempo(true);
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
        }
    }

    useEffect(() => {
        dispatch(setearEjercicioAction('SCR3') );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setComparar(informacion[count-1]);
        setIndexes(Object.keys(informacion).length);
    }, [count, informacion])

    useEffect(() => {
        setResultado(resultadoBase);
    }, [informacion])

    useEffect(() => {
        if(iniciar === false && count === indexes){
            return;
        }else if(iniciar === false && count === 1){
            return;
        } else {
            const newList = JSON.parse(JSON.stringify(contarTiempo));
            newList.push(new Date());
            setContarTiempo(newList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iniciar,count, ultimoTiempo]);

    useEffect(() => {
         if(finalizar){
            const tiempo = JSON.parse(JSON.stringify(contarTiempo));
            const conseguirTiempos = (a) => {
                const t = [];
                for (let i = 0; i < a.length - 1; i++){
                    const despues = new Date(a[i+1]);
                    const antes = new Date(a[i])
                    const segundos = Math.round((date.subtract(despues, antes).toSeconds())*10)/10;
                    t.push(segundos);
                }
                return t
            }
            const tiempoFinal = conseguirTiempos(tiempo);

            const informacion = {
                config,
                payload: {
                    'screening': true,
                    'tiempo': tiempoFinal,
                    'ejercicio': "SCR3",
                    'resultado': resultado,
                    'id_paciente': id_paciente
                }
            }
            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);

    useEffect(() => {
        if(comparar === undefined){
            return;
        }
        const newList = JSON.parse(JSON.stringify(comparar));
        const newComparar = [
            {id:'1', palabra:newList.palabra_1, imagen:newList.imagen_url_1},
            {id:'2', palabra:newList.palabra_2, imagen:newList.imagen_url_2},
            {id:'3', palabra:newList.palabra_3, imagen:newList.imagen_url_3}
        ]

        function shuffle (array) {
            let currentIndex = array.length, randomIndex;
          
            // While there remain elements to shuffle...
            while (currentIndex !== 0) {
          
              // Pick a remaining element...
              randomIndex = Math.floor(Math.random() * currentIndex);
              currentIndex--;
          
              // And swap it with the current element.
              [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
            }
            return array;
        }

        const newShuffleList = shuffle(newComparar);
        
        setRandomPalabra(
            newShuffleList
        )
    }, [comparar]);

    return (
        <Fragment>
        <HeaderEjercicios estrellas={true} carrito={true}/>
        {iniciar
            ?
            <Flex direction="column" height="100%" width="100%">
                {comparar.ejemplo ? 
                <Flex margin="1rem 0 0 2rem" style={{fontSize:"40px", fontFamily:"Nunito", fontWeight:"bold", justifyContent:"start" }}>
                    Ejemplo
                </Flex>
                : null
                }
                <Flex direction="column" margin="auto">
                    <Flex>
                        <Btn 
                        disabled={disable}
                        onClick={() => play(1)} > 
                            <Icono src={`/img/altavoz.png`} alt="" margin="0px 0px 0px 0px" style={{width: "100x"}}/>
                        </Btn>
                        <Btn 
                        disabled={disable}
                        onClick={() => play(2)} > 
                            <Icono src={`/img/altavoz.png`} alt="" margin="0px 0px 0px 0px" style={{width: "100x"}}/>
                        </Btn>
                        <Btn 
                        disabled={disable}
                        onClick={() => play(3)} > 
                            <Icono src={`/img/altavoz.png`} alt="" margin="0px 0px 0px 0px" style={{width: "100x"}}/>
                        </Btn>
                        <Btn 
                        disabled={disable}
                        onClick={() => play(4)} > 
                            <Icono src={`/img/altavoz.png`} alt="" margin="0px 0px 0px 0px" style={{width: "100x"}}/>
                        </Btn>
                        {comparar.cantidad_sonido >= 5 ?
                        <Btn 
                        disabled={disable}
                        onClick={() => play(5)} > 
                            <Icono src={`/img/altavoz.png`} alt="" margin="0px 0px 0px 0px" style={{width: "100x"}}/>
                        </Btn>
                        : null
                        }
                        {comparar.cantidad_sonido >= 6 ?
                        <Btn 
                        disabled={disable}
                        onClick={() => play(6)} > 
                            <Icono src={`/img/altavoz.png`} alt="" margin="0px 0px 0px 0px" style={{width: "100x"}}/>
                        </Btn>
                        : null
                        }
                        {comparar.cantidad_sonido >= 7 ?
                        <Btn 
                        disabled={disable}
                        onClick={() => play(7)} > 
                            <Icono src={`/img/altavoz.png`} alt="" margin="0px 0px 0px 0px" style={{width: "100x"}}/>
                        </Btn>
                        : null
                        }
                    </Flex>
                    <Flex margin="1.5rem 0 0 0">
                        {randomPalabra.map(item => 
                        <Btn margin="0 1.2rem 0 0" style={{border: elegido === item.id ? "black" : null, borderColor: elegido === item.id ? "black" : null, borderStyle: elegido === item.id ? "solid" : null}}
                            disabled={disable}
                            key={item.id}
                            onClick={(e) => (setEjercicioElegido(item.palabra), setElegido(item.id))}
                        >
                            <Ilustracion src={`/img/${item.imagen}.png`} width="8vw" />
                        </Btn>
                        )}
                    </Flex>
                </Flex>
                <Flex margin="0 0rem 0 0rem" width="90%" justify="space-between" display="flex" align="center">
                    <BotoneraBottom miniInstrucciones={miniInstrucciones} />
                    <AvanzarBtn
                        disabled={disable}
                        onClick={(e) => verificar(e)}
                        
                    >
                        <AvanzarImg src={'/img/play.png'} /> 
                    </AvanzarBtn>
                </Flex>
            </Flex>
            :
                <Instrucciones instrucciones={instrucciones} />
        }
    </Fragment>
    );
}
 
export default SCR3;